import { format, utcToZonedTime } from "date-fns-tz";

// You probably already define this somewhere:
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatLocalDate = (
  utcDateStr: string,
  fmt: string = "MMM dd, yyyy, HH:mm:ss"
): string => {
  const utcDate = new Date(utcDateStr + "Z");
  const zonedDate = utcToZonedTime(utcDate, timeZone);
  return format(zonedDate, fmt, { timeZone });
};
